import { render, staticRenderFns } from "./push_video.vue?vue&type=template&id=a286d9d4"
import script from "./push_video.vue?vue&type=script&lang=js"
export * from "./push_video.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports